import { Fancybox } from '@fancyapps/ui';

type Slide = {
  iframeEl: HTMLElement | null
  player: VK.Player | undefined
};

Fancybox.bind('[data-vk-fancybox]', {
  Carousel: {
    preload: 3,
  },
  // groupAttr: 'data-vk-fancybox', // на бою не работает карусель с переключением слайдов, отключили
  on: {
    'Carousel.unselectSlide': (_, __, slide: Slide) => {
      if (slide.player) {
        slide.player.pause();
      }
    },
    'Carousel.selectSlide': (fancybox: Fancybox, __, slide: Slide) => {
      if (!slide.player) {
        if (slide.iframeEl) {
          const player = window.VK.VideoPlayer(slide.iframeEl);
          player.on('ended', () => {
            fancybox.next();
          });

          slide.player = player;
        }
      }
      if (slide.player) {
        slide.player.seek(0);
        slide.player.play();
      }
    },
    'Carousel.removeSlide': (_, __, slide: Slide) => {
      if (slide.player) {
        slide.player.destroy();
        slide.player = undefined;
      }
    },
  },
});
